import _regeneratorRuntime from "/home/forge/academy.truvideo.com/frontend/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/commandcollection
 */
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Collection of commands. Its instance is available in {@link module:core/editor/editor~Editor#commands `editor.commands`}.
 */

var CommandCollection = /*#__PURE__*/function () {
  /**
   * Creates collection instance.
   */
  function CommandCollection() {
    _classCallCheck(this, CommandCollection);

    /**
     * Command map.
     *
     * @private
     * @member {Map}
     */
    this._commands = new Map();
  }
  /**
   * Registers a new command.
   *
   * @param {String} commandName The name of the command.
   * @param {module:core/command~Command} command
   */


  _createClass(CommandCollection, [{
    key: "add",
    value: function add(commandName, command) {
      this._commands.set(commandName, command);
    }
    /**
     * Retrieves a command from the collection.
     *
     * @param {String} commandName The name of the command.
     * @returns {module:core/command~Command}
     */

  }, {
    key: "get",
    value: function get(commandName) {
      return this._commands.get(commandName);
    }
    /**
     * Executes a command.
     *
     * @param {String} commandName The name of the command.
     * @param {*} [...commandParams] Command parameters.
     */

  }, {
    key: "execute",
    value: function execute(commandName) {
      var command = this.get(commandName);

      if (!command) {
        /**
         * Command does not exist.
         *
         * @error commandcollection-command-not-found
         * @param {String} commandName Name of the command.
         */
        throw new CKEditorError('commandcollection-command-not-found: Command does not exist.', this, {
          commandName: commandName
        });
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      command.execute.apply(command, args);
    }
    /**
     * Returns iterator of command names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "names",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
      return _regeneratorRuntime.wrap(function names$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this._commands.keys(), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, names, this);
    })
    /**
     * Returns iterator of command instances.
     *
     * @returns {Iterable.<module:core/command~Command>}
     */

  }, {
    key: "commands",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function commands() {
      return _regeneratorRuntime.wrap(function commands$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.delegateYield(this._commands.values(), "t0", 1);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, commands, this);
    })
    /**
     * Iterable interface.
     *
     * Returns `[ commandName, commandInstance ]` pairs.
     *
     * @returns {Iterable.<Array>}
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._commands[Symbol.iterator]();
    }
    /**
     * Destroys all collection commands.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.commands()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var command = _step.value;
          command.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return CommandCollection;
}();

export { CommandCollection as default };